import { render, staticRenderFns } from "./ProductLogs.vue?vue&type=template&id=07f9aebc"
import script from "./ProductLogs.vue?vue&type=script&lang=js"
export * from "./ProductLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports